import { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  snapDefaultComputer,
  unSnapDefaultComputer,
} from "store/bailiff/(default)/computer/default_computer.action";
//
//component
//redux
//selector
//actions
export const TriggerInit = () => {
  // -------------------------- VAR ----------------------------
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  // -------------------------- USE EFFECT ---------------------
  useEffect(() => {
    dispatch(snapDefaultComputer());
    return () => dispatch(unSnapDefaultComputer());
  }, [dispatch]);
  // -------------------------- RETURN --------------------------
  return <></>;
};
export default TriggerInit;
